/*
 * slick-a11y-fix.js
 * ---------------------------------------------------------------------------
 * Resolves axe / WCAG 4.1.2 "aria-hidden-focus" on Slick carousels.
 *
 * Slick marks every off-screen slide with aria-hidden="true" but leaves the
 * slide (and its links / buttons) in the keyboard tab order. axe flags these
 * because a focusable element must not live inside an aria-hidden subtree.
 *
 * Strategy: when a slide becomes aria-hidden, remove it and its focusable
 * descendants from the TAB ORDER (tabindex="-1") while keeping them
 * mouse-clickable, and restore the original tab order when the slide is
 * revealed. We intentionally avoid the `inert` attribute because Slick's
 * infinite/center modes keep a visually-centered *clone* marked aria-hidden,
 * and `inert` would make that visible clone un-clickable.
 *
 * Framework-agnostic (no jQuery dependency) — driven by a MutationObserver so
 * it works no matter which script initialises each carousel.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var SLIDE = '.slick-slide';
  var FOCUSABLE =
    'a[href],button,input,select,textarea,iframe,[tabindex],[contenteditable="true"]';
  var STORE = 'data-a11y-tabindex';

  function apply(el, hidden) {
    if (hidden) {
      if (!el.hasAttribute(STORE)) {
        el.setAttribute(STORE, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none');
      }
      if (el.getAttribute('tabindex') !== '-1') {
        el.setAttribute('tabindex', '-1');
      }
    } else if (el.hasAttribute(STORE)) {
      var original = el.getAttribute(STORE);
      if (original === 'none') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', original);
      }
      el.removeAttribute(STORE);
    }
  }

  function sync(slide) {
    if (!slide || slide.nodeType !== 1 || !slide.classList.contains('slick-slide')) {
      return;
    }
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    apply(slide, hidden);
    var nodes = slide.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      apply(nodes[i], hidden);
    }
  }

  function scan(root) {
    var slides = (root || document).querySelectorAll(SLIDE);
    for (var i = 0; i < slides.length; i++) {
      sync(slides[i]);
    }
  }

  function closestSlide(node) {
    if (node.nodeType !== 1 || !node.closest) {
      return null;
    }
    return node.closest(SLIDE);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes') {
        var target = m.target;
        var slide =
          target.classList && target.classList.contains('slick-slide')
            ? target
            : closestSlide(target);
        if (slide) {
          sync(slide);
        }
      } else if (m.type === 'childList' && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) {
            continue;
          }
          if (node.classList && node.classList.contains('slick-slide')) {
            sync(node);
          }
          if (node.querySelectorAll) {
            scan(node);
          }
        }
      }
    }
  });

  function start() {
    scan(document);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'tabindex']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
